import React from 'react'
import ShareYourRequirements from "../images/Requirement.png";
import GetExpertsVisit from "../images/Man Expert.png";
import ScheduleYourMove from "../images/Schedule Your Move.jpg";
import SitBackRelax from "../images/Relax img.png";

function WorkProcess() {
  return (
    <div>
        
        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mt-2">
                <div className="back" >
                    <center>
                  <img src={ShareYourRequirements} height="75px" width="80px" alt="ShareYourRequirements"/>
                  </center>
                  <div className="card-body">
                    <center>
                    <h5 style={{ color: "#0b0180ff" }} className="card-title mt-2 mb-2">Tell Us About Your Move</h5>
                    <p className="card-text">Tell us about your move — your new location, preferred moving date, and what needs to be transported</p>
</center>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-2">
                <center>
                <div className="back">
                  <img src={GetExpertsVisit} height="75px" width="80px" alt="GetExpertsVisit"/>
                  <div className="card-body">
                    <h5 style={{ color: "#0b0180ff" }} className="card-title mt-2 mb-2">Schedule Pre-move Survey</h5>
                    <p className="card-text">We will perform a detailed pre-move inspection to ensure an exact and fair pricing quote.</p>
                  </div>
                </div>
                </center>
              </div>
              <div className="col-md-6 mt-2">
                <center>
                <div className="back" >
                  <img src={ScheduleYourMove} height="75px" width="80px" alt="ScheduleYourMove"/>
                  <div className="card-body">
                    <h5 style={{ color: "#0b0180ff" }} className="card-title mt-2 mb-2">Get Free Quotations from AT India Packers</h5>
                    <p className="card-text">Request a free quote from AT India Packers Movers and enjoy the most competitive rates</p>
                  </div>
                </div>
                </center>
              </div>
              <div className="col-md-6 mt-2">
                <center>
                <div className="back" >
                  <img src={SitBackRelax} height="75px" width="80px" alt="Sit Back and Relax"/>
                  <div className="card-body">
                    <h5 style={{ color: "#0b0180ff" }} className="card-title mt-2 mb-2">Sit Back and Relax at best price</h5>
                    <p className="card-text">To ensure value for money, review all moving quotes meticulously before finalizing your mover.</p>
                  </div>
                </div>
                </center>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default WorkProcess